// extracted by mini-css-extract-plugin
export default {"admin-header":"AdminHeader_admin-header__VRRbm","admin-header-return":"AdminHeader_admin-header-return__EuiG5"};